export default {
  title: `Sorry, we couldn't find any products matching your filters`,
  backBtn: `Back to previous results`
}
